document.addEventListener("DOMContentLoaded", function () {


/* =====================================
   SAVE DELIVERY DETAILS TO SHOPIFY CART
   Date + Slot + Location + Personal Message
   ALL AS CART ATTRIBUTES

   FIX (13-Oct-2026): this used to write the
   CURRENT PAGE's date/slot/message to the cart
   unconditionally - including on every product
   page load (date defaults to today, slot and
   message are empty on load) and on every cart /
   checkout click. So a customer who picked e.g.
   16 Oct 3-8 PM + a message on product A, then
   opened product B (an add-on card, another
   bouquet), had the cart reset to TODAY /
   "No slot selected" / "No message from customer"
   before checkout. ~1 in 3 orders (#TF46306,
   #TF46280, #TF46272 ...) arrived that way.

   Now:
   - only fields the customer actually set on
     THIS page (deliveryTouched) overwrite the
     cart;
   - untouched fields keep the value already in
     the cart, falling back to the defaults only
     if the cart has none (or the cart is empty,
     or its date is already in the past);
   - saves run one at a time, in order, so a
     slower earlier save can't land last.
===================================== */

var deliveryTouched = {
    date: false,
    slot: false,
    message: false
};

window.markDeliveryTouched = function (field) {
    deliveryTouched[field] = true;
};

var DEFAULT_SLOT = "No slot selected";
var DEFAULT_MESSAGE = "No message from customer";

var saveQueue = Promise.resolve();

function formatDate(date) {

    return date.getFullYear() + "-" +
        String(date.getMonth() + 1).padStart(2, "0") + "-" +
        String(date.getDate()).padStart(2, "0");

}

function readPageDeliveryDetails() {

    /* =====================================
       DELIVERY ELEMENTS
    ===================================== */

    var cityElement =
        document.getElementById("selected-city");

    var dateElement =
        document.getElementById("selected-delivery-date");

    var slotElement =
        document.getElementById("selected-delivery-slot");


    /* =====================================
       CITY
    ===================================== */

    var city =
        cityElement
            ? cityElement.textContent.trim()
            : (localStorage.getItem("selectedCity") || "");


    /* =====================================
       DELIVERY DATE
       Date already defaults to TODAY
    ===================================== */

    var deliveryDate =
        dateElement && dateElement.value
            ? dateElement.value
            : (
                document.getElementById(
                    "custom-delivery-date"
                )?.value || ""
            );


    /* =====================================
       DELIVERY SLOT
    ===================================== */

    var deliverySlot =
        slotElement && slotElement.value
            ? slotElement.value
            : DEFAULT_SLOT;


    /* =====================================
       PERSONAL MESSAGE
    ===================================== */

    var personalMessageField =
        document.querySelector(
            '#gift-message, ' +
            '#personal-message, ' +
            '#personal_message, ' +
            'textarea[name="Personal Message"], ' +
            'textarea[name="personal_message"], ' +
            'textarea[placeholder="Write your message"]'
        );


    var personalMessage =
        personalMessageField &&
        personalMessageField.value.trim()
            ? personalMessageField.value.trim()
            : DEFAULT_MESSAGE;

    return {
        city: city,
        date: deliveryDate,
        slot: deliverySlot,
        personalMessage: personalMessage
    };

}

function buildDeliveryAttributes(page, cart) {

    var existing =
        cart && cart.item_count > 0 && cart.attributes
            ? cart.attributes
            : {};

    var todayString =
        formatDate(new Date());

    /* A date left in the cart from an earlier
       day is stale - don't carry it (or its
       slot) forward. */
    var existingIsStale =
        !existing["Delivery-Date"] ||
        existing["Delivery-Date"] < todayString;

    var date =
        deliveryTouched.date || existingIsStale
            ? page.date
            : existing["Delivery-Date"];

    /* An existing slot only belongs to the
       existing date - if the customer moved to a
       different date here without picking a slot,
       don't pair the old slot with the new date. */
    var keepExistingSlot =
        !existingIsStale &&
        date === existing["Delivery-Date"];

    var slot =
        deliveryTouched.slot
            ? page.slot
            : (keepExistingSlot && existing["Delivery-Time"]) || page.slot;

    var message =
        deliveryTouched.message
            ? page.personalMessage
            : existing["Personal Message"] || page.personalMessage;

    return {
        city: page.city,
        date: date,
        slot: slot,
        personalMessage: message
    };

}

window.saveDeliveryDetailsToCart = function () {

    var run = function () {

        var page =
            readPageDeliveryDetails();

        return fetch(
            window.Shopify.routes.root + "cart.js"
        )

        .then(function (response) {

            return response.ok ? response.json() : null;

        })

        .catch(function () {

            return null;

        })

        .then(function (cart) {

            var details =
                buildDeliveryAttributes(page, cart);


            /* =====================================
               DEBUG
            ===================================== */

            console.log(
                "Saving delivery details to cart:",
                {
                    city: details.city,
                    date: details.date,
                    slot: details.slot,
                    personalMessage: details.personalMessage,
                    touched: deliveryTouched
                }
            );


            /* =====================================
               CART ATTRIBUTES
               Shopify merges these keys into the
               cart's existing attributes, so other
               keys (e.g. "Flowers picked") are left
               alone.
            ===================================== */

            var formData =
                new FormData();


            formData.append(
                "attributes[Delivery-Date]",
                details.date
            );


            formData.append(
                "attributes[Delivery-Time]",
                details.slot
            );


            formData.append(
                "attributes[Delivery-Location]",
                details.city
            );


            formData.append(
                "attributes[Personal Message]",
                details.personalMessage
            );


            /* =====================================
               SAVE TO SHOPIFY CART
            ===================================== */

            return fetch(
                window.Shopify.routes.root + "cart/update.js",
                {
                    method: "POST",
                    body: formData
                }
            );

        })

        .then(function (response) {

            if (!response.ok) {

                throw new Error(
                    "Failed to save delivery details to cart."
                );

            }

            return response.json();

        })

        .then(function (cart) {

            console.log(
                "Delivery details saved successfully:",
                cart.attributes
            );

            return cart;

        });

    };

    var result =
        saveQueue.then(run, run);

    saveQueue =
        result.catch(function () {});

    return result.catch(function (error) {

        console.error(
            "Delivery details could not be saved:",
            error
        );

        throw error;

    });

};

/* =====================================
   PERSONAL MESSAGE
   SAVE WHEN CUSTOMER FINISHES EDITING

   FIX (13-Oct-2026): also mirror the message
   into a "Personal Message" line-item property
   on the product form (as Delivery Date /
   Delivery Slot already are), per Shopflo's
   request - line-item properties can't be
   reset by a later page, so this is a backup
   copy on the order line.
===================================== */

var personalMessageField =
    document.getElementById("gift-message");

function syncPersonalMessageProperty() {

    var dateInputInForm =
        document.getElementById("selected-delivery-date");

    var form =
        dateInputInForm && dateInputInForm.form;

    if (!form || !personalMessageField) {
        return;
    }

    var propertyInput =
        form.querySelector('input[name="properties[Personal Message]"]');

    if (!propertyInput) {

        propertyInput = document.createElement("input");
        propertyInput.type = "hidden";
        propertyInput.name = "properties[Personal Message]";
        propertyInput.id = "selected-personal-message";
        form.appendChild(propertyInput);

    }

    var message =
        personalMessageField.value.trim();

    propertyInput.value = message;

    /* Don't submit an empty property */
    propertyInput.disabled = !message;

}

if (personalMessageField) {

    syncPersonalMessageProperty();

    personalMessageField.addEventListener(
        "input",
        function () {

            deliveryTouched.message = true;

            syncPersonalMessageProperty();

        }
    );

    personalMessageField.addEventListener(
        "change",
        function () {

            console.log(
                "Personal Message changed:",
                personalMessageField.value
            );

            deliveryTouched.message = true;

            syncPersonalMessageProperty();

            if (
                typeof window.saveDeliveryDetailsToCart ===
                "function"
            ) {

                window.saveDeliveryDetailsToCart();

            }

        }
    );


    personalMessageField.addEventListener(
        "blur",
        function () {

            if (!deliveryTouched.message) {
                return;
            }

            if (
                typeof window.saveDeliveryDetailsToCart ===
                "function"
            ) {

                window.saveDeliveryDetailsToCart();

            }

        }
    );

}

/* =====================================
   DELIVERY DATE
===================================== */

var todayCard = document.getElementById("today-card");
var tomorrowCard = document.getElementById("tomorrow-card");
var thirdDateCard = document.getElementById("third-date-card");
var moreCard = document.getElementById("more-date-card");

var dateInput = document.getElementById("custom-delivery-date");

var selectedDeliveryDateInput =
    document.getElementById("selected-delivery-date");

var dateCards =
    document.querySelectorAll(".date-card");


/* =====================================
   SUBSCRIPTION CHECK
===================================== */

var subscriptionData =
    document.getElementById("product-subscription-data");

var subscriptionMessage =
    document.getElementById("subscription-message");

var deliveryDateSection =
    document.querySelector(".delivery-date");


var isSubscriptionProduct =
    subscriptionData &&
    subscriptionData.dataset.subscription === "true";


if (isSubscriptionProduct) {

    if (deliveryDateSection) {
        deliveryDateSection.style.display = "none";
    }

    if (subscriptionMessage) {
        subscriptionMessage.style.display = "block";
    }

}


function updateDateCard(card, date, label) {

    if (!card || !date) {
        return;
    }

    var day =
        date.toLocaleDateString("en-US", {
            weekday: "short"
        }).toUpperCase();

    var number =
        date.getDate();

    var month =
        date.toLocaleDateString("en-US", {
            month: "short"
        }).toUpperCase();

    var dayElement =
        card.querySelector(".day");

    var numberElement =
        card.querySelector(".number");

    var monthElement =
        card.querySelector(".month");


    if (dayElement) {
        dayElement.textContent =
            label || day;
    }

    if (numberElement) {
        numberElement.textContent =
            number;
    }

    if (monthElement) {
        monthElement.textContent =
            month;
    }

}


var today = new Date();

today.setHours(0, 0, 0, 0);

var tomorrow =
    new Date(today);

tomorrow.setDate(
    tomorrow.getDate() + 1
);

var thirdDate =
    new Date(today);

thirdDate.setDate(
    thirdDate.getDate() + 2
);

updateDateCard(todayCard, today, "TODAY");
updateDateCard(tomorrowCard, tomorrow, "TOMORROW");
updateDateCard(thirdDateCard, thirdDate);

if (dateInput) {

    var year =
        today.getFullYear();

    var month =
        String(today.getMonth() + 1).padStart(2, "0");

    var day =
        String(today.getDate()).padStart(2, "0");

    dateInput.min =
        year + "-" + month + "-" + day;
}

if (todayCard) {
    todayCard.classList.add("active");
}

if (dateInput) {

    var year =
        today.getFullYear();

    var month =
        String(today.getMonth() + 1).padStart(2, "0");

    var day =
        String(today.getDate()).padStart(2, "0");

    dateInput.value =
        year + "-" + month + "-" + day;

}

/* FIX (13-Oct-2026): `save` is false for the
   page-load default (today) - that must only fill
   this page's form, never overwrite a date the
   customer already chose on another product. */
function setSelectedDeliveryDate(date, save) {

    if (!date) {
        console.warn("Delivery date not provided.");
        return;
    }

    if (!selectedDeliveryDateInput) {
        console.error("Hidden delivery date input #selected-delivery-date was not found.");
        return;
    }

    var formattedDate =
        formatDate(date);

    selectedDeliveryDateInput.value =
        formattedDate;

    console.log("Selected Delivery Date:", formattedDate);

    if (save === false) {
        return;
    }

    deliveryTouched.date = true;

    if (typeof window.saveDeliveryDetailsToCart === "function") {
        window.saveDeliveryDetailsToCart();
    }

}

setSelectedDeliveryDate(today, false);

dateCards.forEach(function(card) {

    card.addEventListener("click", function() {

        if (isSubscriptionProduct) {
            return;
        }

        if (card.id === "more-date-card") {

            if (dateInput) {

                if (typeof dateInput.showPicker === "function") {
                    dateInput.showPicker();
                } else {
                    dateInput.click();
                }

            }

            return;
        }

        dateCards.forEach(function(item) {
            item.classList.remove("active");
        });

        card.classList.add("active");

        var selectedDate = null;

        if (card.id === "today-card") {
            selectedDate = new Date(today);
        }
        else if (card.id === "tomorrow-card") {
            selectedDate = new Date(tomorrow);
        }
        else if (card.id === "third-date-card") {
            selectedDate = new Date(thirdDate);
        }

        if (selectedDate && dateInput) {

            var year =
                selectedDate.getFullYear();

            var month =
                String(selectedDate.getMonth() + 1).padStart(2, "0");

            var day =
                String(selectedDate.getDate()).padStart(2, "0");

            dateInput.value =
                year + "-" + month + "-" + day;

        }

        if (selectedDate) {
            setSelectedDeliveryDate(selectedDate);
        }

        if (selectedDate && typeof setDeliverySlotDate === "function") {
            setDeliverySlotDate(selectedDate);
        }

    });

});

if (dateInput) {

    dateInput.addEventListener("change", function() {

        if (isSubscriptionProduct) {
            return;
        }

        if (!this.value) {
            return;
        }

        var selected =
            new Date(this.value + "T00:00:00");

        setSelectedDeliveryDate(selected);

        dateCards.forEach(function(card) {
            card.classList.remove("active");
        });

        if (selected.getTime() === today.getTime()) {
            todayCard.classList.add("active");
        }
        else if (selected.getTime() === tomorrow.getTime()) {
            tomorrowCard.classList.add("active");
        }
        else if (selected.getTime() === thirdDate.getTime()) {
            thirdDateCard.classList.add("active");
        }
        else if (moreCard) {
            moreCard.classList.add("active");
            updateDateCard(moreCard, selected);
        }

        if (typeof setDeliverySlotDate === "function") {
            setDeliverySlotDate(selected);
        }

    });

}

/* =====================================
   DELIVERY SLOT
   City selection itself (popup, header/sticky
   sync, redirect-on-change) now lives in
   custom.js and runs site-wide. This section
   only renders the slot list for whatever
   city custom.js has already resolved, via
   the shared window.cityDeliveryConfig /
   window.currentCityId.
===================================== */

var slotSubscriptionData =
    document.getElementById("product-subscription-data");

var slotSubscriptionMessage =
    document.getElementById("subscription-message");

var deliverySlotSection =
    document.querySelector(".delivery-slot");

var slotIsSubscriptionProduct =
    slotSubscriptionData &&
    slotSubscriptionData.dataset.subscription === "true";

if (slotIsSubscriptionProduct) {

    if (deliverySlotSection) {
        deliverySlotSection.style.display = "none";
    }

    if (slotSubscriptionMessage) {
        slotSubscriptionMessage.style.display = "block";
    }

}

var selectedDeliveryDate = new Date();

selectedDeliveryDate.setHours(0, 0, 0, 0);

function renderSlotsForCity(cityId) {

    var container = document.getElementById("slot-list-container");

    if (!container) {
        return;
    }

    container.innerHTML = "";

    var selectedDeliverySlotInput = document.getElementById("selected-delivery-slot");

    if (selectedDeliverySlotInput) {
        selectedDeliverySlotInput.value = "";
    }

    var cityData = window.cityDeliveryConfig && window.cityDeliveryConfig[cityId];

    if (!cityData || !cityData.slots) {
        return;
    }

    cityData.slots.forEach(function (slotData) {

        var slotEl = document.createElement("div");

        slotEl.className = "slot";
        slotEl.dataset.slot = slotData.value;
        slotEl.dataset.close = slotData.cutoff;

        var labelEl = document.createElement("small");
        labelEl.textContent = slotData.label;
        slotEl.appendChild(labelEl);

        slotEl.addEventListener("click", function () {
            handleSlotClick(this);
        });

        container.appendChild(slotEl);

    });

    updateSlotStatus();

}

function handleSlotClick(slotEl) {

    if (slotEl.classList.contains("disabled")) {
        return;
    }

    var container = document.getElementById("slot-list-container");

    if (container) {
        container.querySelectorAll(".slot").forEach(function (item) {
            item.classList.remove("active");
        });
    }

    slotEl.classList.add("active");

    var selectedSlot = slotEl.dataset.slot;

    console.log("Selected Delivery Slot:", selectedSlot);

    var selectedDeliverySlotInput = document.getElementById("selected-delivery-slot");

    if (selectedDeliverySlotInput) {

        selectedDeliverySlotInput.value = selectedSlot;

        /* Picking a slot also confirms the date
           currently shown on this page. */
        deliveryTouched.slot = true;
        deliveryTouched.date = true;

        if (typeof window.saveDeliveryDetailsToCart === "function") {
            window.saveDeliveryDetailsToCart();
        }

        console.log("Delivery Slot saved:", selectedDeliverySlotInput.value);

    } else {

        console.warn("Delivery slot hidden input not found.");

    }

}

function updateSlotStatus() {

    var container = document.getElementById("slot-list-container");

    if (!container) {
        return;
    }

    var slots = container.querySelectorAll(".slot");

    if (slotIsSubscriptionProduct) {

        slots.forEach(function (slot) {
            slot.classList.remove("disabled");
            slot.classList.remove("time-closed");
            slot.classList.remove("active");
        });

        return;
    }

    var today = new Date();
    today.setHours(0, 0, 0, 0);

    var selectedDate = new Date(selectedDeliveryDate);
    selectedDate.setHours(0, 0, 0, 0);

    if (selectedDate.getTime() > today.getTime()) {

        slots.forEach(function (slot) {
            slot.classList.remove("time-closed");
            slot.classList.remove("disabled");
        });

        return;
    }

    var now = new Date();
    var currentTime = now.getHours() * 60 + now.getMinutes();

    slots.forEach(function (slot) {

        var slotName = slot.dataset.slot;
        var closeTime = slot.dataset.close;

        if (!closeTime) {
            return;
        }

        var parts = closeTime.split(":");
        var closeHours = parseInt(parts[0], 10);
        var closeMinutes = parseInt(parts[1], 10);
        var slotCloseTime = closeHours * 60 + closeMinutes;

        if (currentTime >= slotCloseTime) {
            slot.classList.add("time-closed");
        } else {
            slot.classList.remove("time-closed");
        }

        if (slot.classList.contains("time-closed")) {

            if (slot.classList.contains("active")) {

                var selectedDeliverySlotInput = document.getElementById("selected-delivery-slot");

                if (selectedDeliverySlotInput && selectedDeliverySlotInput.value === slotName) {

                    selectedDeliverySlotInput.value = "";

                    console.warn("Delivery slot expired and was cleared:", slotName);

                    /* The slot this customer picked on
                       this page is no longer valid, so
                       clearing it is a real change. */
                    deliveryTouched.slot = true;

                    if (typeof window.saveDeliveryDetailsToCart === "function") {
                        window.saveDeliveryDetailsToCart();
                    }

                }

            }

            slot.classList.add("disabled");
            slot.classList.remove("active");

        } else {

            slot.classList.remove("disabled");

        }

    });

}

function setDeliverySlotDate(date) {

    if (!date) {
        return;
    }

    selectedDeliveryDate = new Date(date);
    selectedDeliveryDate.setHours(0, 0, 0, 0);

    console.log("Selected delivery date:", selectedDeliveryDate);

    updateSlotStatus();

}

/* Initial slot render for whatever city custom.js has already resolved.
   custom.js runs earlier in document order and its DOMContentLoaded
   handler registers first, so window.currentCityId is already set by
   the time this handler runs. */
if (window.currentCityId) {
    renderSlotsForCity(window.currentCityId);
}

setInterval(function () {
    updateSlotStatus();
}, 60000);

var checkBtn = document.getElementById("check-pincode");
var pinInput = document.getElementById("delivery-pincode");
var status = document.getElementById("delivery-status");

if (checkBtn && pinInput && status) {

    checkBtn.addEventListener("click", function () {

        var pin = pinInput.value.trim();

        if (pin.length !== 6) {
            status.innerHTML = "❌ Please enter a valid 6-digit PIN.";
            status.style.color = "#d93025";
            return;
        }

        var cityData = window.currentCityId && window.cityDeliveryConfig && window.cityDeliveryConfig[window.currentCityId];

        if (cityData && cityData.pincodes && cityData.pincodes.includes(pin)) {
            status.innerHTML = "✅ Delivery Available";
            status.style.color = "#000";
        } else {
            status.innerHTML = "❌ Delivery Not Available";
            status.style.color = "#d93025";
        }

    });

    pinInput.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
            event.preventDefault();
            checkBtn.click();
        }
    });

}

});


/* =====================================
   SUBSCRIPTION PRODUCT CHECK
===================================== */

document.addEventListener("DOMContentLoaded", function () {

    var subscriptionData =
        document.getElementById("product-subscription-data");

    var deliveryDate =
        document.querySelector(".delivery-date");

    var deliverySlot =
        document.querySelector(".delivery-slot");

    var subscriptionMessage =
        document.getElementById("subscription-message");

    if (!subscriptionData) {
        console.log("Subscription data not found");
        return;
    }

    var isSubscription =
        subscriptionData.dataset.subscription === "true";

    console.log("Subscription product:", isSubscription);

    if (isSubscription) {

        if (deliveryDate) {
            deliveryDate.style.display = "none";
        }

        if (deliverySlot) {
            deliverySlot.style.display = "none";
        }

        if (subscriptionMessage) {
            subscriptionMessage.style.display = "block";
        }

    }

    else {

        if (deliveryDate) {
            deliveryDate.style.display = "";
        }

        if (deliverySlot) {
            deliverySlot.style.display = "";
        }

        if (subscriptionMessage) {
            subscriptionMessage.style.display = "none";
        }

    }

});
